module.exports = __webpack_public_path__ + "img/img15.33328a2a.svg";